export enum PAYMENT_SCREEN {
  DEFAULT = 'default',
  VOUCHER = 'voucher',
  SUBSCRIPTION = 'subscription',
}
